import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import Cookies from 'js-cookie';

const root = ReactDOM.createRoot(document.getElementById('root'));
const initialData = window.__INITIAL_DATA__ || {};
const language = Cookies.get('lang') || 'en';

console.log('Client initialData:', initialData); // Debug log

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <App initialData={initialData} language={language} />
    </BrowserRouter>
  </HelmetProvider>
);

reportWebVitals();
